import { Pipe, PipeTransform } from '@angular/core';
import { ScheduleWithTimeZone } from '@mode/shared/schedules/contract';
@Pipe({
  standalone: true,
  name: 'timeWithTimeZone',
})
export class TimeWithTimeZonePipe implements PipeTransform {
  transform(schedule: ScheduleWithTimeZone): string {
    return `${this.hourDisplay(schedule)}:${this.minuteDisplay(schedule)} ${this.amOrPm(schedule)} ${
      schedule.timeZone
    }`;
  }

  private hourDisplay(schedule: ScheduleWithTimeZone) {
    const militaryTimeDiff = 12;
    switch (true) {
      case schedule.hour > 12:
        return schedule.hour - militaryTimeDiff;
      case schedule.hour === 0:
        return 12;
      default:
        return schedule.hour;
    }
  }

  private minuteDisplay(schedule: ScheduleWithTimeZone) {
    switch (true) {
      case schedule.minute < 10:
        return `0${schedule.minute}`;
      default:
        return schedule.minute;
    }
  }

  private amOrPm(schedule: ScheduleWithTimeZone) {
    return schedule.hour > 11 ? 'pm' : 'am';
  }
}
